import FormAsignacionPresupuestoAreas from "./Form"

export default function AgregarAreaPresup() {
    return (
        <>
            <FormAsignacionPresupuestoAreas data={JSON.parse(localStorage.getItem("preuniejearea"))}/>
        </>
    )
}